module.exports = __webpack_public_path__ + "static/img/quality_management.da48fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/quality_management.png
// module id = Hd+6
// module chunks = 1